<template>
    <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card color= "grey lighten-5">
           <v-flex xs12 sm12>
            <v-toolbar   size="120px" dark color="info">
                <v-toolbar-title >{{dialog_baslik}}</v-toolbar-title>

            </v-toolbar>
        </v-flex>
            <v-card-text>
              <v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                <v-layout wrap>

                          <div class="flex md12">
                    <div v-show="codegorunum === true ">
                      <v-text-field label="Banka Kodu" :color="color"  v-model="Banka.BankCode" :error-messages="errors.collect('bankakod')" v-validate="'required'"
                        data-vv-name="bankakod" required>
                      </v-text-field>
                    </div>
                    <v-text-field label="Banka Adı" :color="color"  v-model="Banka.BankName" :error-messages="errors.collect('bankaadi')" v-validate="'required'"
                      data-vv-name="bankaadi" required>
                    </v-text-field>
                    <v-text-field label="Banka Kısa Kodu" :color="color"  v-model="Banka.BankShortName"></v-text-field>
                    <v-autocomplete label="Cari Seçiniz" :color="color" clearable append-icon="search"  :loading="loading" :items="state" item-text="text" cache-items=""
                      item-value="id" :search-input.sync="search" v-model="Banka.Account"></v-autocomplete>
                          </div>
                </v-layout>
</v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-show="m === true">
                <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
                <v-btn id="bsil" color="blue darken-1" flat @click="deletebanka()">Sİl</v-btn>
              </div>
              <div v-show="k === true">
                <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
              </div>
              <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout row wrap>
        <v-toolbar   size="120px" dark color="info">
          <v-toolbar-title >Banka</v-toolbar-title>
          <v-spacer></v-spacer>
           <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
          <v-btn hidden="xs" flat @click="bankaekle()"> Banka Ekle
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </v-toolbar>
      </v-layout>

      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-data-table :headers="headers" :rows-per-page-items=[50,100]  :loading="progress" :items="items" :search="search3">
          <v-progress-linear slot="progress"   indeterminate></v-progress-linear>

          <template slot="items" slot-scope="props">
            <tr @click="Getir(props.item.BankaKod)" item>
              <td class="text-xs-left">{{ props.item.SirketKodu }}</td>
              <td class="text-xs-left">{{ props.item.BankaKod }}</td>
              <td class="text-xs-left">{{ props.item.BankaAdi }}</td>
              <td class="text-xs-left">{{ props.item.BankaKisaKod }}</td>
              <td class="text-xs-left">{{ props.item.Kod }}</td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
          </v-alert>
        </v-data-table>
      </v-card>

      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Şirket Kodu',
            value: 'SirketKodu'
          },
          {
            text: 'Banka Kodu',
            value: 'BankaKod'
          },
          {
            text: 'Banka Adı',
            value: 'BankaAdi'
          },
          {
            text: 'Banka Kısa Kodu',
            value: 'BankaKisaKod'
          },
          {
            text: 'CariKod',
            value: 'Kod'
          }

        ],
        loading: false,
        color:'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        Banka: {
          CompanyCode:'',
          BankCode: '',
          BankName: '',
          BankShortName: '',
          Account: ''
        },
        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress:false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            bankaadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Banka Güncelle'

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

var params = {
  CompanyCode:credentials.SirketKodu,
          BankCode: v
        }
        this.$http.post(auth.API_URL + 'api/Bank/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Banka.BankCode = response.body[0].BankaKod
          this.Banka.BankName = response.body[0].BankaAdi
          this.Banka.BankShortName = response.body[0].BankaKisaKod

          var params2 = response.body[0].Kod

          this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
            params2
          }, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.state = response.body
          })
          this.Banka.Account = response.body[0].Kod
          this.search = response.body[0].Kod



        })
      },
      deletebanka: deletebanka,
      bankaekle: bankaekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      carigetir: carigetir,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
    this.Banka.Account = ''
    this.bankaadi = ''
    this.bankakod = ''
    this.Banka.BankCode = ''
    this.Banka.BankName = ''
  }


  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.state = response.body
        }, (response) => {
          if (response.status === 0) {
           this.text1 = 'Service Unavailable'
              this.snackbar = true
          } else {
        this.text1 = 'Service Unavailable'
              this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

var params1 = {
  CompanyCode:credentials.SirketKodu
}
        this.Banka.CompanyCode=credentials.SirketKodu
        var params = this.Banka
        this.$http.post(auth.API_URL + 'api/Bank/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/Bank/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
this.text1 = 'Service Unavailable'
              this.snackbar = true                  } else {
this.text1 = 'Service Unavailable'
              this.snackbar = true                  }
            })

          }
        }, (response) => {
          if (response.status === 0) {
this.text1 = 'Service Unavailable'
              this.snackbar = true              } else {
this.text1 = 'Service Unavailable'
              this.snackbar = true              }
        })
      }
    })
  }

  function bankaekle() {

    this.dialog = true
    this.Banka = {}
    this.dialog_baslik = 'Banka Ekle'
    this.m = false
    this.k = true
    this.bankaadi = ''
    this.bankakod = ''
    this.Banka.BankCode = ''
    this.Banka.BankName = ''
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

var params = {
  CompanyCode:credentials.SirketKodu
}
    this.progress=true
    this.$http.post(auth.API_URL + 'api/Bank/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress=false
    }, (response) => {
      if (response.status === 0) {
        this.progress=false
        this.text1 = 'Service Unavailable'
              this.snackbar = true
      } else {
      this.progress=false
        this.text1 = 'Service Unavailable'
              this.snackbar = true      }
    })
  }

  function deletebanka() {
    if (window.confirm('Bankay\'ı silmek istediğinizden eminmisiniz?')) {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

     var  params1 = {
  CompanyCode:credentials.SirketKodu
}
this.Banka.CompanyCode=credentials.SirketKodu
      var params = this.Banka
      this.$http.post(auth.API_URL + 'api/Bank/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.$http.post(auth.API_URL + 'api/Bank/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.search = response.body.Tarih
            this.dialog = false


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
        this.text1 = 'Service Unavailable'
              this.snackbar = true            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
      this.progress=false
        this.text1 = 'Service Unavailable'
              this.snackbar = true        } else {
      this.progress=false
        this.text1 = 'Service Unavailable'
              this.snackbar = true        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

var params1 = {
  CompanyCode:credentials.SirketKodu
}
this.Banka.CompanyCode=credentials.SirketKodu
        var params = this.Banka
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Bank/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = 'Güncelleme işlemi tamamlandı'
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/Bank/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>

</style>